<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="secondary">
            <div class="container">

                <b-navbar-brand v-if="!isAdmin" :to="{ name: 'Events' }">
                    <img src="@/assets/images/logo.png" class="logo_img" />
                </b-navbar-brand>
                <b-navbar-brand v-if="isAdmin" :to="{ name: 'Events' }">
                    <img src="@/assets/images/logo.png" class="logo_img" />
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav v-if="Object.keys(getUserDetails).length > 0">

                    <!-- normal user menu-->
                    <b-navbar-nav  v-if="!isAdmin">
                        <b-nav-item :to="{ name: 'Events' }" exact active-class="active">Dogodki</b-nav-item>
                        <b-nav-item :to="{ name: 'EventEvaluation' }" exact active-class="active" v-if="getUserDetails.email === 'sitka.tepeh@dobra-pot.si' || getUserDetails.email === 'jana.gombac@dobra-pot.si'">Evalvacija</b-nav-item>
                        <b-nav-item :to="{ name: 'WorkHoursReport' }" active-class="active" v-if="userData.isEmployed">Delo</b-nav-item>
                        <b-nav-item :to="{ name: 'VacationDaysReport' }" active-class="active" v-if="userData.isEmployed">Dopust</b-nav-item>
                        <b-nav-item :to="{ name: 'VolunteerWorkHoursReport' }" active-class="active">Prostovoljstvo</b-nav-item>
                        <b-nav-item :to="{ name: 'Orchids' }" exact active-class="active" v-if="getUserDetails.email === 'sitka.tepeh@dobra-pot.si'">Orhideje</b-nav-item>
                    </b-navbar-nav>

                    <!-- admin user menu-->
                    <b-navbar-nav  v-if="isAdmin">
                        <b-nav-item :to="{ name: 'Events' }" exact active-class="active">Dogodki</b-nav-item>
                        <b-nav-item :to="{ name: 'EventEvaluation' }" exact active-class="active">Evalvacija</b-nav-item>
                        <b-nav-item :to="{ name: 'Projects' }" exact active-class="active">Projekti</b-nav-item>
                        <b-nav-item :to="{ name: 'AdminWorkHoursReport' }" active-class="active">Delo</b-nav-item>
                        <b-nav-item :to="{ name: 'AdminVacationDaysReport' }" active-class="active">Dopust</b-nav-item>
                        <b-nav-item :to="{ name: 'AdminVolunteerWorkHoursReport' }" active-class="active">Prostovoljstvo</b-nav-item>
                        <b-nav-item :to="{ name: 'Users' }" exact active-class="active">Uporabniki</b-nav-item>
                        <b-nav-item :to="{ name: 'Orchids' }" exact active-class="active">Orhideje</b-nav-item>
                    </b-navbar-nav>

                    <div class="ml-auto" v-if="Object.keys(getUserDetails).length > 0">

                        <b-dropdown dropdown :text="userData.first_name + ' ' + userData.last_name" variant="primary" class="m-2">
                            <b-dropdown-item @click="logout()">Odjavi se</b-dropdown-item>
                        </b-dropdown>

                    </div>

                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'Header',
    data: function () {
      return {
        userData: {},
        isAdmin: sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")).administrator : false
      }
    },
    updated() {
      console.log("Updated");
      this.isAdmin = sessionStorage.getItem("DP_user") ? JSON.parse(sessionStorage.getItem("DP_user")).administrator : false
    },
    computed: {
      getUserDetails() {
        this.userData = this.$store.getters.getUserDetails;
        return this.$store.getters.getUserDetails;
      }
    },
    mounted () {
      let _this = this;
      _this.$store.dispatch("retrieveUserDetails");
    },
    methods: {
      logout() {
        const _this = this;
        _this.userData = {};
        sessionStorage.clear();
        _this.$store.dispatch("retrieveUserDetails");
        _this.$router.replace('/login');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue